import KeyIcon from 'assets/Icons/KeyIcon';
import Image from 'next/image';

import { formatPrice } from '@/utils/Product';

import { ShouldRender } from '../../shared/basic/ShouldRender';
import CustomLoader from '../../shared/Loading';
import { FormattedFinalOrder } from '../../../utils/interfaces/Orders';

interface Props {
  order: FormattedFinalOrder;
  loadingOrder: boolean;
}

const SidePanel: React.FC<Props> = ({ order, loadingOrder }) => {
  return (
    <>
      <div className=' text-fadedWhite  z-10  w-full  flex flex-col  rounded-md cardShadow lg:pt-[172px] 2xl:px-[52px] xl:px-[42px] lg:px-[32px] px-4'>
        <div className='flex flex-col gap-y-5'>
          <span className='sm:text-xl text-sm font-bold uppercase leading-[100%] sm:mb-[50px] mb-5'>
            PRICE SUMMARY
          </span>
        </div>
        <div className='flex flex-col  '>
          <div className=' customScrollBar flex flex-col gap-y-10 sm:mb-[50px] mb-[32px]'>
            {order?.orderDetails?.map((item) => {
              return (
                <div
                  key={item.id}
                  className='flex items-center justify-between xl:gap-10 lg:gap-5 gap-10'
                >
                  <div className='flex sm:gap-5 gap-2 items-center'>
                    <div className='relative w-[62px] h-[42px] overflow-hidden bg-imageCardBgColorCart rounded-lg'>
                      <div className='absolute top-0 left-0 w-full flex justify-center'>
                        <Image
                          src={item.image}
                          alt='Product'
                          width={200}
                          height={200}
                          className='object-contain w-[30px] h-auto mt-1.5'
                        />
                      </div>
                    </div>
                    <div className='flex flex-col flex-1'>
                      <div className='flex  text-textGray font-medium sm:text-sm text-xs leading-4  gap-2 sm:mb-3 mb-2'>
                        <span className='font-medium'>
                          Qty : {item.quantity}
                        </span>
                      </div>
                      <span className='xl:text-base lg:text-sm sm:text-base text-sm/[18px] text-white font-medium leading-[18px] capitalize'>
                        {item.name} - {item?.book_type}
                      </span>
                    </div>
                  </div>
                  <div className='sm:text-base text-sm font-semibold text-white whitespace-nowrap'>
                    {item?.currency_symbol} {formatPrice(item.price)} /-
                  </div>
                </div>
              );
            })}
          </div>
          <div className='border border-cartBgColor ' />
          <div className='flex justify-between gap-x-4 sm:py-[30px] py-[18px]'>
            <div className='sm:text-base text-sm/6 leading-6 font-normal whitespace-nowrap'>
              Order number
            </div>
            <p className='sm:text-xl text-lg/[26px] leading-6 text-white font-semibold'>
              {order?.orderId}
            </p>
          </div>
          <div className='border border-cartBgColor' />
          <div className='flex justify-between gap-x-4 sm:py-[30px] py-[18px]'>
            <div className='sm:text-base text-sm/6 leading-6 font-normal whitespace-nowrap'>
              Order total
            </div>
            {order?.payment_type === 'subscription' ? (
              <div className='flex items-center gap-2'>
                <b>01</b>
                <KeyIcon />
              </div>
            ) : (
              <p className='sm:text-xl text-lg/[26px] leading-6 text-white font-semibold'>
                {order?.currency} {formatPrice(order?.grand_total)}
              </p>
            )}
          </div>
        </div>
      </div>
      <ShouldRender check={loadingOrder}>
        <div className='flex justify-center  py-40'>
          <CustomLoader />
        </div>
      </ShouldRender>
    </>
  );
};

export default SidePanel;
